import { UserLayout, BasicLayout, RouteView, PageView } from '@/components/layouts'

// 角色对应表
export const roleEnum = {
  CLERK: 'clerk',//店员
  MANAGER: 'manager',//店长
  MERCHANDISER: 'merchandiser',//采购
  OPERATIONS: 'operations',//运营
  ADMIN: 'admin',//管理员
}

export const asyncRouterMap = [

  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/dashboard',
    children: [
      // dashboard
      {
        path: '/dashboard',
        name: 'dashboard',
        component: PageView,
        redirect: '/dashboard/way_goods',
        meta: { title: '工作台', icon: 'dashboard', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS, roleEnum.CLERK] },
        children: [
          {
            path: '/dashboard/stock',
            name: 'StockList',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Stock'),
            meta: { title: '门店库存', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },

          {
            path: '/dashboard/stock/allocation',
            name: 'allocation',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/dashboard/allocation'),
            hidden: true,
            meta: { title: '库存调拨', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/dashboard/stock/allocation/record',
            name: 'allocationRecord',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/dashboard/allocationRecord'),
            hidden: true,
            meta: { title: '调拨记录', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/dashboard/stock/allocation/record/detail/:id',
            name: 'AllocationRecordDetail',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/dashboard/AllocationRecordDetail'),
            hidden: true,
            meta: { title: '调拨详情', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/dashboard/way_goods',
            name: 'WayGoods',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/WayGoods'),
            meta: { title: '在途总表', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS, roleEnum.CLERK] }
          },
          {
            path: '/dashboard/way_goods/:id/list',
            name: 'WayGoodsList',
            hidden: true,
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/WayGoodsList'),
            meta: { title: '在途总表/收货', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/dashboard/way_goods/:id/detail',
            name: 'WayGoodsDetail',
            hidden: true,
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/WayGoodsDetail'),
            meta: { title: '在途总表 / 操作日志', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          // {
          //   path: '/dashboard/inventory',
          //   name: 'InventoryList',
          //   component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/InventoryList'),
          //   meta: { title: '盘点表', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS,roleEnum.CLERK] }
          // },
          { //新盘点列表页面
            path: '/dashboard/inventory',
            name: 'InventoryList',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/NewInventoryList'),
            meta: { title: '盘点表', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS, roleEnum.CLERK] }
          },
          // {
          //   path: '/dashboard/settleAccounts',
          //   name: "SettleAccounts",
          //   component: () => import('@/views/dashboard/SettleAccounts'),
          //   meta: { title: '日结存单', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          // },
          { //库存异动列表页面
            path: '/dashboard/abnormalInventoryChange',
            name: 'AbnormalInventoryChange',
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/AbnormalInventoryChangeList'),
            meta: { title: '库存异动审阅', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/dashboard/reviewInventory',
            name: 'ReviewInventory',
            hidden: true,
            component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/ReviewInventory'),
            meta: { title: '复盘盘点表', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS, roleEnum.CLERK] }
          },
          {
            path: '/dashboard/stock/:id',
            name: 'stockDetail',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/dashboard/stockDetail'),
            hidden: true,
            meta: { title: '门店库存/库存记录', role: [roleEnum.CLERK, roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
        ]
      },

      // goods
      {
        path: '/goods',
        name: 'goods',
        component: PageView,
        redirect: '/goods/list',
        meta: { title: '商品管理', icon: 'form', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS, roleEnum.CLERK] },
        children: [
          {
            path: '/goods/list',
            name: 'GoodsList',
            component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/GoodsList'),
            meta: { title: '商品列表', role: [roleEnum.MANAGER, roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS, roleEnum.CLERK] }
          },
          {
            path: '/goods/add',
            name: 'AddGoods',
            component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/AddGoods'),
            meta: { title: '新增商品', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          {
            path: '/goods/edit',
            name: 'EditGoods',
            component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/EditGoods'),
            hidden: true,
            meta: { title: '更新商品', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          // {
          //   path: '/goods/changeRecord',
          //   name: 'ChangeRecord',
          //   hidden: true,
          //   component: () => import(/* webpackChunkName: "goods" */ '@/views/goods/ChangeRecord'),
          //   meta: { title: '库存异动记录', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          // },
        ]
      },

      // order
      {
        path: '/order',
        name: 'order',
        component: PageView,
        redirect: '/order/list',
        meta: { title: '订单管理', icon: 'table', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS, roleEnum.MANAGER] },
        children: [
          {
            path: '/order/list',
            name: 'OrderList',
            component: () => import(/* webpackChunkName: "order" */ '@/views/order/OrderList'),
            meta: { title: '订单列表', keepAlive: 'true', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS, roleEnum.MANAGER] }
          },
          // {
          //   path: '/order/data',
          //   name: 'OrderData',
          //   hidden:true,
          //   component: () => import(/* webpackChunkName: "order" */ '@/views/order/OrderData'),
          //   meta: { title: '订单数据', keepAlive:'true', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN ,roleEnum.OPERATIONS] }
          // },
          // {
          //   path: '/order/:id',
          //   name: 'ViewOrder',
          //   component: () => import(/* webpackChunkName: "order" */ '@/views/order/Order'),
          //   hidden: true,
          //   meta: { title: '订单详情', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN,roleEnum.OPERATIONS] }
          // }
        ]
      },

      // user
      {
        path: '/user',
        name: 'user',
        component: RouteView,
        redirect: '/user/list',
        meta: { title: '用户管理', icon: 'user', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] },
        children: [
          {
            path: '/user/list',
            name: 'UserList',
            component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserList'),
            meta: { title: '用户列表', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/record/list',
            name: 'UserRecordList',
            component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserRecordList'),
            meta: { title: '充值查询', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/recharge',
            name: 'Recharge',
            component: () => import(/* webpackChunkName: "user" */ '@/views/user/Recharge'),
            meta: { title: '娃娃充值', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] }
          },
          {
            path: '/user/list/:id',
            name: 'userRecord',
            hidden: true,
            component: () => import(/* webpackChunkName: "user" */ '@/views/user/userRecord'),
            meta: { title: '查看', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/user/list/game_coin/:id',
            name: 'gameCoin',
            hidden: true,
            component: () => import(/* webpackChunkName: "user" */ '@/views/user/userGameCoinRecord'),
            meta: { title: '查看', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          // {
          //   path: '/sponsor/list',
          //   name: 'UserSponsor',
          //   component: () => import(/* webpackChunkName: "user" */ '@/views/user/UserSponsor'),
          //   meta: { title: '赞助查询', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN] }
          // },
        ]
      },

      // setting
      {
        path: '/setting',
        name: 'setting',
        component: PageView,
        redirect: '/setting/branch',
        meta: { title: '设置管理', icon: 'setting', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] },
        children: [
          {
            path: '/setting/branch',
            name: 'Branch',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/Branch'),
            meta: { title: '店铺管理', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/setting/area',
            name: 'Area',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/Area'),
            meta: { title: '区域管理', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/setting/category',
            name: 'Category',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/Category'),
            meta: { title: '分类管理', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/setting/banner',
            name: 'Banner',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/Banner'),
            meta: { title: '轮播图管理', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/setting/equipment',
            name: 'Equipment',
            component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/Equipment'),
            meta: { title: '设备管理', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] }
          },
          {
            path: '/setting/equipment/readings/:id',
            name: 'EquipmentReadings',
            hidden: true,
            component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/EquipmentReadings'),
            meta: { title: '抄表记录', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          // {
          //   path: '/setting/brand',
          //   name: 'Brand',
          //   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/Brand'),
          //   meta: { title: '品牌管理', role: [roleEnum.MERCHANDISER] }
          // },
          // {
          //   path: '/setting/tag',
          //   name: 'Tag',
          //   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/Tag'),
          //   meta: { title: '标签管理', role: [roleEnum.MERCHANDISER] }
          // },
          // {
          //   path: '/setting/fee-template',
          //   name: 'FeeTemplate',
          //   component: () => import(/* webpackChunkName: "setting" */ '@/views/setting/FeeTemplate'),
          //   meta: { title: '邮费管理', role: [roleEnum.MERCHANDISER] }
          // },
        ]
      },
      // account
      // {
      //   path: '/account',
      //   component: RouteView,
      //   name: 'account',
      //   hidden: true,
      //   meta: { title: '个人页', icon: 'user', role: [ roleEnum.MERCHANDISER, roleEnum.ADMIN] },
      //   children: [
      //     {
      //       path: '/account/center',
      //       name: 'center',
      //       component: () => import('@/views/account/Center'),
      //       meta: { title: '个人中心', role: [ roleEnum.MERCHANDISER, roleEnum.ADMIN] }
      //     },
      //     {
      //       path: '/account/change',
      //       name: 'change',
      //       component: () => import('@/views/account/ChangePass'),
      //       meta: { title: '修改密码', role: [ roleEnum.MERCHANDISER, roleEnum.ADMIN]  },
      //     },
      //   ]
      // },
      // manage
      // {
      //   path: '/manage',
      //   component: RouteView,
      //   name: 'manage',
      //   meta: { title: '比赛管理', icon: 'bank', role: [ roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, 'guest' ] },
      //   children: [
      //     {
      //       path: '/manage/recharge',
      //       name: 'recharge',
      //       component: () => import('@/views/manage/Recharge'),
      //       meta: { title: '娃娃充值', role: [ roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, 'guest' ] }
      //     },
      //     // {
      //     //   path: '/manage/exchange',
      //     //   name: 'exchange',
      //     //   component: () => import('@/views/manage/Exchange'),
      //     //   meta: { title: '娃娃兑换', role: [ roleEnum.MANAGER ]  },
      //     // },
      //   ]
      // },

      // purchase
      {
        path: '/purchase',
        name: 'purchase',
        component: PageView,
        redirect: '/purchase/OptionList',
        meta: { title: '兑换货采购平台', icon: 'table', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] },
        children: [
          {
            path: '/purchase/OptionList',
            name: 'OptionList',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/purchase/OptionList'),
            meta: { title: '选款页面', keepAlive: 'true', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          {
            path: '/purchase/cart',
            name: 'Cart',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/purchase/Cart'),
            meta: { title: '订单记录', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          {
            path: '/purchase/BuyList',
            name: 'BuyList',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/purchase/BuyList'),
            meta: { title: '订单总表', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          {
            path: '/purchase/log/:id',
            name: 'purchaseLog',
            hidden: true,
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/purchase/Log'),
            meta: { title: '订单总表 / 操作日志', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          {
            path: '/purchase/abnormal',
            name: 'Abnormal',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/purchase/Abnormal'),
            meta: { title: '异常订单', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          {
            path: '/purchase/BuyDetail/:id',
            name: 'BuyDetail',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/purchase/BuyDetail'),
            hidden: true,
            meta: { title: '订单详情', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          {
            path: '/purchase/abnormaltail/:id',
            name: 'Abnormaltail',
            component: () => import(/* webpackChunkName: "purchase" */ '@/views/purchase/Abnormaltail'),
            hidden: true,
            meta: { title: '异常订单详情', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
        ]
      },
      //smallpurchase
      // { 
      //   path: '/smallpurchase',
      //   name: 'smallpurchase',
      //   component: PageView,
      //   redirect: '/smallpurchase/option',
      //   meta: { title: '小货采购平台', icon: 'table', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN ] },
      //   children: [
      //     {
      //       path: '/smallpurchase/option',
      //       name: 'SOptionList',
      //       component: () => import(/* webpackChunkName: "smallpurchase" */ '@/views/smallpurchase/OptionList'),
      //       meta: { title: '选款页面', keepAlive:'true', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN ] }
      //     },
      //     {
      //       path: '/smallpurchase/cart',
      //       name: 'SCart',
      //       component: () => import(/* webpackChunkName: "smallpurchase" */ '@/views/smallpurchase/Cart'),
      //       meta: { title: '订单记录', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN ] }
      //     },
      //     {
      //       path: '/smallpurchase/list',
      //       name: 'SBuyList',
      //       component: () => import(/* webpackChunkName: "smallpurchase" */ '@/views/smallpurchase/BuyList'),
      //       meta: { title: '订单总表', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN,'finance' ] }
      //     },
      //     {
      //       path: '/smallpurchase/abnormal',
      //       name: 'SAbnormal',
      //       component: () => import(/* webpackChunkName: "smallpurchase" */ '@/views/smallpurchase/Abnormal'),
      //       meta: { title: '异常订单', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN ] }
      //     },
      //     {
      //       path: '/smallpurchase/:id/detail',
      //       name: 'SBuyDetail',
      //       component: () => import(/* webpackChunkName: "smallpurchase" */ '@/views/smallpurchase/BuyDetail'),
      //       hidden: true,
      //       meta: { title: '订单详情', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN ] }
      //     },
      //     {
      //       path: '/smallpurchase/:id/abnormaltail',
      //       name: 'SAbnormaltail',
      //       component: () => import(/* webpackChunkName: "smallpurchase" */ '@/views/smallpurchase/Abnormaltail'),
      //       hidden: true,
      //       meta: { title: '异常订单详情', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN ] }
      //     },
      //     {
      //       path: '/smallpurchase/upload',
      //       name: 'Upload',
      //       component: () => import(/* webpackChunkName: "smallpurchase" */ '@/views/smallpurchase/Upload'),
      //       meta: { title: '图片上传', role: [roleEnum.MERCHANDISER,roleEnum.ADMIN ] }
      //     },
      //   ]
      // },

      // setting
      {
        path: '/making',
        name: 'making',
        component: PageView,
        meta: { title: '采购管理', icon: 'setting', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] },
        children: [
          {
            path: '/making/supplier',
            name: 'Supplier',
            component: () => import(/* webpackChunkName: "making" */ '@/views/making/Supplier'),
            meta: { title: '供应商管理', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          },
          // {
          //   path: '/making/pay',
          //   name: 'PayList',
          //   component: () => import(/* webpackChunkName: "making" */ '@/views/making/PayList'),
          //   meta: { title: '付款订单', role: [ roleEnum.MERCHANDISER,'finance' ] }
          // },
          // {
          //   path: '/making/analysis',
          //   name: 'test',
          //   component: () => import(/* webpackChunkName: "making" */ '@/views/making/test'),
          //   meta: { title: '分析页', role: [ roleEnum.MERCHANDISER ] }
          // },
          // {
          //   path: '/making/copytables',
          //   name: 'CopyTables',
          //   component: () => import(/* webpackChunkName: "making" */ '@/views/making/CopyTables'),
          //   meta: { title: '抄码表', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          // },
          // {
          //   path: '/making/analytable',
          //   name: 'AnalyTable',
          //   component: () => import(/* webpackChunkName: "making" */ '@/views/making/AnalyTable'),
          //   meta: { title: '数据分析表', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN] }
          // },
          // {
          //   path: '/making/stock',
          //   name: 'StockData',
          //   component: () => import(/* webpackChunkName: "making" */ '@/views/making/StockData'),
          //   meta: { title: '库存数据表', role: [ roleEnum.MERCHANDISER,roleEnum.ADMIN ] }
          // },

        ]
      },
      {
        path: '/staff',
        name: 'staff',
        component: PageView,
        meta: { title: '员工管理', icon: 'user', role: [roleEnum.ADMIN] },
        children: [
          {
            path: '/staff/list',
            name: 'StaffList',
            component: () => import(/* webpackChunkName: "staff" */ '@/views/staff/staffList'),
            meta: { title: '员工列表', role: [roleEnum.ADMIN] }
          },
        ]
      },
      {
        path: '/mall',
        name: 'mall',
        component: PageView,
        redirect: '/mall/goods',
        meta: { title: '在线商城管理', icon: 'shop', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] },
        children: [
          {
            path: '/mall/goods/create',
            name: 'mallGoodsCreate',
            component: () => import(/* webpackChunkName: "mall" */ '@/views/mall/mallGoodsAdd'),
            meta: { title: '新建商品', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] },
          },
          {
            path: '/mall/goods/:id/edit',
            name: 'mallGoodsEdit',
            hidden: true,
            component: () => import(/* webpackChunkName: "mall" */ '@/views/mall/mallGoodsEdit'),
            meta: { title: '编辑商品', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] },
          },
          //sku操作日志
          {
            path: '/mall/goods/sku/:id/log',
            name: 'mallGoodsSkuLog',
            hidden: true,
            component: () => import(/* webpackChunkName: "mall" */ '@/views/mall/mallGoodsSkuLog'),
            meta: { title: 'sku操作日志', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] },
          },
          {
            path: '/mall/goods',
            name: 'mallGoods',
            component: () => import(/* webpackChunkName: "mall" */ '@/views/mall/mallGoods'),
            meta: { title: '查看商品', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] },
          },
          {
            path: '/mall/order',
            name: 'mallOrder',
            component: () => import(/* webpackChunkName: "mall" */ '@/views/mall/mallOrder'),
            meta: { title: '订单管理', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.OPERATIONS] },
          },
        ]
      },
      //扫码操作
      {
        path: '/scan',
        name: 'scan',
        component: PageView,
        redirect: '/scan/doll',
        meta: { title: '扫码操作', icon: 'scan', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] },
        children: [
          //扫码设置积分
          {
            path: '/scan/doll',
            name: 'scanDoll',
            component: () => import(/* webpackChunkName: "scan" */ '@/views/scan/Doll'),
            meta: { title: '操作积分', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] },
          },
          //扫码存币
          {
            path: '/scan/save_coin',
            name: 'scanSaveCoin',
            component: () => import(/* webpackChunkName: "scan" */ '@/views/scan/SaveCoin'),
            meta: { title: '存币', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] },
          },
          //扫码取币
          {
            path: '/scan/take_coin',
            name: 'scanTakeCoin',
            component: () => import(/* webpackChunkName: "scan" */ '@/views/scan/TakeCoin'),
            meta: { title: '取币', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] },
          },
          //礼品兑换
          {
            path: '/scan/exchange',
            name: 'scanExchange',
            component: () => import(/* webpackChunkName: "scan" */ '@/views/scan/Exchange'),
            meta: { title: '礼品兑换', role: [roleEnum.ADMIN, roleEnum.MANAGER] },
          },
          //退货退款
          {
            path: '/scan/refund',
            name: 'scanRefund',
            component: () => import(/* webpackChunkName: "scan" */ '@/views/scan/Refund'),
            meta: { title: '退货退款', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] },
          },
          //核销必中卡
          {
            path: '/scan/optional_card',
            name: 'scanOptionalCard',
            component: () => import(/* webpackChunkName: "scan" */ '@/views/scan/OptionalCard'),
            meta: { title: '核销必中卡', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] },
          },
          //核销欢乐券
          {
            path: '/scan/happy_coupon',
            name: 'scanHappyCoupon',
            component: () => import(/* webpackChunkName: "scan" */ '@/views/scan/HappyCoupon'),
            meta: { title: '核销欢乐券', role: [roleEnum.MERCHANDISER, roleEnum.ADMIN, roleEnum.MANAGER, roleEnum.OPERATIONS, roleEnum.CLERK] },
          },
        ]
      }
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/auth',
    component: UserLayout,
    redirect: '/auth/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/Login')
      }
    ]
  },
  {
    path: '/top',
    meta: { title: '门店排行榜' },
    component: () => import('@/views/top'),
    hidden: true,
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/404')
  },
]
